import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { ToastService } from '@services/toast.service';

import { NomExportTransportTypes } from '../constants';
import { EditorFormEntity } from '../models/form.models';

import {
  shareFailure,
  shareSuccess,
  shareCancelled,
} from './object.actions';
import { submitFormFailure } from './form.actions';

import { map, tap } from 'rxjs/operators';

// ! Share-flow UI orchestration only - the share/export HTTP lives in
// ! `ObjectPersistenceService`, which dispatches these broadcasts.

@Injectable()
export class ShareEffects {
  shareCancelled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(shareCancelled),
      tap(() =>
        this.toastService.showWarning(
          this.translate.instant('export-form.export-cancelled'),
        ),
      ),
      // A cancel must clear the ExportForm's `saving` flag - the export dialog
      // watches the form state, not the share actions.
      map(({ objectId }) =>
        submitFormFailure({
          entity: EditorFormEntity.ExportForm,
          error: {
            message: this.translate.instant('export-form.export-cancelled', {
              objectId,
            }),
          },
        }),
      ),
    ),
  );

  shareFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(shareFailure),
        tap(({ error }) => {
          this.toastService.showError(
            this.translate.instant('msg.export.export-failed', {
              error: error?.message || error,
            }),
          );
        }),
      ),
    { dispatch: false },
  );

  shareFileSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(shareSuccess),
        tap((action) => {
          if (action.response.type === NomExportTransportTypes.FILE) {
            if (action?.response?.download_url) {
              const link = document.createElement('a');
              link.href = action.response.download_url;
              link.download = 'download';
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          } else {
            this.toastService.showSuccess(
              this.translate.instant('msg.export.success'),
            );
          }
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private translate: TranslateService,
    private toastService: ToastService,
  ) {}
}
